export default __webpack_public_path__ + "static/media/01_DAIF_Data_03_01.0427845c.mp4";